export default __webpack_public_path__ + "static/media/H1015.3.28aea0bc.mp3";